export type SimpleUserRole = 'cashier' | 'manager';

export const SIMPLE_USER_ROLES = ['cashier', 'manager'] as const satisfies readonly SimpleUserRole[];

export interface SimpleUser {
  id: string;
  organization_id: string;
  username: string;
  is_active: boolean;
  role: SimpleUserRole;
  created_at: string;
  updated_at: string;
}
